import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	for: {
		id: 'dynamic-cards-search-page.atlas.for',
		defaultMessage: 'for',
		description: 'The conjunction between a status and date e.g. "On track for August"',
	},
	'townsquare.api.goal-state.archived': {
		id: 'dynamic-cards-search-page.townsquare.api.goal-state.archived',
		defaultMessage: 'Archived',
		description: 'Label of Archived state',
	},
	'townsquare.api.goal-state.off-track': {
		id: 'dynamic-cards-search-page.townsquare.api.goal-state.off-track',
		defaultMessage: 'Off track',
		description: 'Label of Off track state',
	},
	'townsquare.api.goal-state.at-risk': {
		id: 'dynamic-cards-search-page.townsquare.api.goal-state.at-risk',
		defaultMessage: 'At risk',
		description: 'Label of At risk state',
	},
	'townsquare.api.goal-state.on-track': {
		id: 'dynamic-cards-search-page.townsquare.api.goal-state.on-track',
		defaultMessage: 'On track',
		description: 'Label of On track state',
	},
	'townsquare.api.goal-state.pending': {
		id: 'dynamic-cards-search-page.townsquare.api.goal-state.pending',
		defaultMessage: 'Pending',
		description: 'Label of Pending state',
	},
	'townsquare.api.goal-state.paused': {
		id: 'dynamic-cards-search-page.townsquare.api.goal-state.paused',
		defaultMessage: 'Paused',
		description: 'Label of Paused state',
	},
	'townsquare.api.goal-state.completed': {
		id: 'dynamic-cards-search-page.townsquare.api.goal-state.completed',
		defaultMessage: 'Completed',
		description: 'Label of Completed state',
	},
	'townsquare.api.goal-state.cancelled': {
		id: 'dynamic-cards-search-page.townsquare.api.goal-state.cancelled',
		defaultMessage: 'Cancelled',
		description: 'Label of Cancelled state',
	},
});
